
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","data-name":"Layer 1","viewBox":"0 0 24 24","fill":"currentcolor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.9 11.437A12 12 0 000 13a11.878 11.878 0 003.759 8.712A4.84 4.84 0 007.113 23h9.767a4.994 4.994 0 003.509-1.429A11.944 11.944 0 0023.9 11.437zm-4.909 8.7A3 3 0 0116.88 21H7.113a2.862 2.862 0 01-1.981-.741A9.9 9.9 0 012 13a10.014 10.014 0 013.338-7.457A9.881 9.881 0 0111.986 3a10.553 10.553 0 011.174.066 9.994 9.994 0 015.831 17.076zM7.807 17.285a1 1 0 01-1.4 1.43A8 8 0 0112 5a8.072 8.072 0 011.143.081 1 1 0 01.847 1.133.989.989 0 01-1.133.848 6 6 0 00-5.05 10.223zm12.112-5.428A8.072 8.072 0 0120 13a7.931 7.931 0 01-2.408 5.716 1 1 0 01-1.4-1.432 5.98 5.98 0 001.744-5.141 1 1 0 011.981-.286zm-5.993.631a2.033 2.033 0 11-1.414-1.414l3.781-3.781a1 1 0 111.414 1.414z"}})])
          )
        }
      }
    